// extracted by mini-css-extract-plugin
export default {"container":"styles__container___1r1+j","aligned":"styles__aligned___ULubR","linkButton":"styles__linkButton___lGZ8R","lastLine":"styles__lastLine___+aGAH"};